import './ProgressBarFullness.scss'
import React, { useState } from 'react'
import { ProgressBar } from 'primereact/progressbar'

const ProgressBarFullness = (props: { value: number }) => {
  const [value1, setValue1] = useState(0)

  const displayValueTemplate = () => {
    return <React.Fragment></React.Fragment>
  }

  return (
    <div className="progressBarFullness">
      <ProgressBar
        value={props.value}
        displayValueTemplate={displayValueTemplate}
        color={props.value < 34 ? '#CAD3FC' : props.value < 67 ? '#9DAAEB' : '#5868B8'}></ProgressBar>
    </div>
  )
}
export default ProgressBarFullness
